import { useEffect, useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { Field } from "@/lib/finance";
import { useAuth } from "@/context/AuthContext";

const FIELDS = [["title", "Ticari Unvan", 2], ["tax_office", "Vergi Dairesi"], ["tax_no", "Vergi No"], ["mersis_no", "MERSİS No"], ["phone", "Telefon"],
  ["email", "E-posta"], ["iban", "IBAN", 2], ["address", "Adres", 3]];

export default function CompanyTab() {
  const { can } = useAuth();
  const edit = can("ayarlar", "edit");
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  useEffect(() => { api.get("/settings/company").then(({ data }) => setF(data)); }, []);
  if (!f) return <div className="panel h-48 animate-pulse" />;
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.put("/settings/company", Object.fromEntries([...FIELDS.map(([k]) => [k, f[k] || ""]), ["logo_path", f.logo_path || ""]])); setF(data); toast.success("Firma bilgileri kaydedildi"); }
    catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try { const { data } = await api.post("/files/company-logo", fd); setF({ ...f, logo_path: data.path, logo_url: data.url }); toast.success("Logo yüklendi – kaydetmeyi unutmayın"); }
    catch (err) { toast.error(apiError(err)); }
  };
  return (
    <form onSubmit={save} className="panel p-4 space-y-4" data-testid="company-settings">
      <div className="flex items-center gap-4">
        {f.logo_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${f.logo_url}`} alt="Logo" className="h-16 w-auto border rounded p-1" data-testid="company-logo-preview" />
          : <div className="h-16 w-16 border border-dashed rounded text-[10px] text-slate-400 flex items-center justify-center">LOGO</div>}
        {edit && <>
          <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={upload} data-testid="company-logo-input" />
          <Button type="button" variant="outline" size="sm" onClick={() => fileRef.current?.click()} data-testid="company-logo-upload"><Upload className="h-4 w-4 mr-1" />Logo Yükle</Button>
          {f.logo_path && <Button type="button" variant="ghost" size="sm" onClick={() => setF({ ...f, logo_path: "", logo_url: "" })} data-testid="company-logo-remove">Kaldır</Button>}
        </>}
        <span className="text-[11px] text-slate-500">Fatura, proforma ve makbuz çıktılarının başlığında kullanılır.</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {FIELDS.map(([k, l, span]) => <Field key={k} label={l} className={span === 3 ? "col-span-2 md:col-span-3" : span ? "col-span-2" : ""}>
          <Input value={f[k] || ""} disabled={!edit} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`company-${k}`} /></Field>)}
      </div>
      {edit && <Button type="submit" disabled={busy} className="bg-blue-600 hover:bg-blue-700" data-testid="company-save">{busy && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Kaydet</Button>}
    </form>
  );
}
